import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=31904de2&scoped=true&"
import script from "./UserEdit.vue?vue&type=script&lang=js&"
export * from "./UserEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=31904de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31904de2",
  null
  
)

export default component.exports